import React, { useEffect, useState } from 'react';
import { useBreadcrumbs, useUser } from '../hooks';
import { Header, Table, Label, Groupper, Input, Pagination, Icon, Toast } from 'react-frontier';
import { Link } from 'react-router-dom';
import { EventDateList } from '../SiteClasses';
import { firstBy } from 'thenby';
import API from '../API';
import moment from 'moment';
import { Statistic } from 'semantic-ui-react';

const PAGE_SIZE = 20;

interface MyEventsProps {
}

var MyEvents = (props: MyEventsProps)=>{
	var { setTitle } = useBreadcrumbs();
	var { user } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [events, setEvents] = useState<EventDateList[]>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchEvents, setSearchEvents] = useState<EventDateList[]>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [totalCounts, setTotalCounts] = useState<{ operating: number, closed: number }>(null);

	useEffect(()=>{
		setTitle('Mis Eventos');
		get();
		getTotalCounts();
	}, []);

	var getTotalCounts = ()=>{
		API.getEventsCount(user?.user_id).then(res=>{
			if(res.error) return;
			setTotalCounts({ operating: Number(res.data.operating), closed: Number(res.data.closed) });
		}).catch(err=>{
			Toast.error('Hubo un error al cargar los conteos de eventos. (GEC-1)');
		});
	};

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;

		setLoading(true);
		API.getMyEvents(offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setEvents(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los eventos. (GME-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
		setLoading(true)
		setPage(page);
		get(page);
	}

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length < 3) {
			return setSearchEvents(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	}

	var search = (query: string)=>{
		setSearching(true);
		setSearchEvents(null);
		API.searchEvents(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			var filteredEvents = res.data.filter(e => e.user_coordinator === user?.user_id || e.user_executive === user?.user_id);
			setSearchEvents(filteredEvents);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar eventos. (SME-1)');
		}).finally(()=>{
			setSearching(false);
		})
	}

	if(loadError) { return <Header text='Error' subtext={loadError} /> };
	if(!events) { return <Header text='Cargando datos' loading /> };

	var shown_events = (searchEvents || events).sort(
		firstBy<EventDateList>((a, b) => (a.closed ? 1 : 0) - (b.closed ? 1 : 0))
	);

	return <div>
		<Groupper
			title={'Mis Eventos'}
			style={{ marginTop: 20 }}
			width={1000}
		>
			<div style={{ display: 'flex', justifyContent: 'space-around', padding: '5px 0', marginBottom: -15 }}>
				<Statistic size='small'>
					<Statistic.Value style={{ color: '#2185d0' }}>
						{totalCounts ? totalCounts.operating : '-'}
					</Statistic.Value>
					<Statistic.Label>Operando</Statistic.Label>
				</Statistic>
				<Statistic size='small'>
					<Statistic.Value style={{ color: '#db2828' }}>
						{totalCounts ? totalCounts.closed : '-'}
					</Statistic.Value>
					<Statistic.Label>Cerrados</Statistic.Label>
				</Statistic>
				<Statistic size='small'>
					<Statistic.Value style={{ color: 'black' }}>
						{totalCounts ? totalCounts.operating + totalCounts.closed : '-'}
					</Statistic.Value>
					<Statistic.Label>Total</Statistic.Label>
				</Statistic>
			</div>
			<Groupper.Divider></Groupper.Divider>
			<Input placeholder='Buscar eventos...' value={filter} onChange={onSearchChange} />
			<Table striped fitted selectable
				className='first last'
				style={{ marginTop: 15 }}
				headers={['ID', 'Evento', 'Fecha', 'Ciudad', 'Promotor', 'Estatus', 'Boletos', 'Cortesías']}
				centeredIndexes={[5]}
				footer={(!!shown_events && shown_events.length >= PAGE_SIZE || page !== 0) && (
					<Table.Cell colSpan={8} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_events.length >= PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={8}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_events.length !== 0 ? (
						shown_events.map(e => (
							<Table.Row
								compact
								key={e.date_id}
								as={Link}
								to={`/events/${e.date_id}`}
								collapsingIndexes={[0, 2, 3, 6, 7]}
								centeredIndexes={[5, 6, 7]}
								data={[
									e.date_id,
									e.event_name,
									moment.unix(e.date).format('DD/MM/YY HH:mm'),
									e.city || <Icon name='minus'/>,
									e.promoter_name || 'Sin asignar',
									<Label style={{ width: 100, padding: 0 }} color={e.closed ? 'red' : 'blue'}>{e.closed ? 'Cerrado' : 'Operando'}</Label>,
									e.tickets_sold?.toLocaleString() || '0',
									e.tickets_free?.toLocaleString() || '0',
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={8}>
							<Header text={filter.length >= 3 ? 'No se encontraron eventos' : 'No tienes eventos asignados'} />
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
	</div>
}

export default MyEvents;
